import $ from "jquery";

window.$ = window.jQuery = $;

function runCopyLinkFunc() {
    $(document).ready(function () {
        console.log("copy script loaded...");
        const $copyButtons = $(".button__copy");

        $copyButtons.click(function () {
            this.classList.add("button__copied");
            this.innerHTML = "Solution address copied";

            const copyContent = async () => {
                try {
                    await navigator.clipboard.writeText(this.getAttribute("data"));
                } catch (err) {
                    alert("Failed to copy to clipboard. ", err);
                }
            };

            copyContent();

            setTimeout(() => {
                this.classList.remove("button__copied");
                this.innerHTML = "Copy address to this solution";
            }, 5000);
        });
    });
}

runCopyLinkFunc();

export default runCopyLinkFunc;
